<template>
  <section class="peak_line">
    <i />
    <svg :style="{
            width:`${expand.wave.size*expand.wave.margin+expand.wave.padding*2}px`,
            height:`${expand.wave.amplitude*2+expand.wave.padding*2}px`
        }">
      <defs>
        <linearGradient id="gradient">
          <stop offset="0%" stop-color="#f5f6fb" stop-opacity="0" />
          <stop offset="30%" stop-color="#3F5CEC" />
          <stop offset="70%" stop-color="#3F5CEC" />
          <stop offset="100%" stop-color="#f5f6fb" stop-opacity="0" />
        </linearGradient>
      </defs>
      <path ref="svgPath" stroke="url(#gradient)"
            d="" />
      <circle ref="svgCircle_1" cx="-99" cy="-99" r="4"
              :style="{fill:'#3F5CEC'}" />
      <circle ref="svgCircle_2" cx="-99" cy="-99" r="4"
              :style="{fill:'#3F5CEC'}" />
      <circle ref="svgCircle_3" cx="-99" cy="-99" r="4"
              :style="{fill:'#3F5CEC'}" />
      <circle ref="svgCircle" cx="-99" cy="-99" r="6"
              :style="{fill:'#0dddf0',opacity:expand.wave.current/expand.wave.line.length}" />
    </svg>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_peakLine',
  data(): DataInterface {
    return {
      expand: {
        active: true,
        wave: {
          line: [],
          padding: 10,
          margin: 3,
          size: 200,
          offset: 16,
          time: 0,
          amplitude: 40,
          length: 25,
          current: 0,
          speed: 3
        },
        circle: {
          current: 0,
          target: 0,
          speed: 1,
          point: [ 32, 200 / 2, 200 - 32 ]
        }
      }
    };
  },
  mounted(): void {
    this.setCircle(2);
    this.initWave();
    this.playWave();
    this.playCircle();
  },
  beforeUnmount(): void {
    this.expand.active = false;
  },
  methods: {
    /**
     * 初始化波浪
     */
    initWave(): void {
      const size = this.expand.wave.size / 2;
      
      for (let i = 0; i < size; i++) {
        const point = $FN.Math.threeBezier(
          i / size,
          [ 0, this.expand.wave.amplitude ], [ size, -this.expand.wave.amplitude ],
          [ 0, this.expand.wave.amplitude * 2 ], [ size, -this.expand.wave.amplitude ]
        );
        
        this.expand.wave.line.push([
          i * this.expand.wave.margin + this.expand.wave.padding,
          point[1] + this.expand.wave.amplitude + this.expand.wave.padding
        ]);
      }
      for (let i = 0; i <= size; i++) {
        const point = $FN.Math.threeBezier(
          i / size,
          [ size, -this.expand.wave.amplitude ], [ this.expand.wave.size, -this.expand.wave.amplitude / 2 ],
          [ size, -this.expand.wave.amplitude ], [ this.expand.wave.size, this.expand.wave.amplitude ]
        );
        
        this.expand.wave.line.push([
          (i + 100) * this.expand.wave.margin + this.expand.wave.padding,
          point[1] + this.expand.wave.amplitude + this.expand.wave.padding
        ]);
      }
      
      for (let i = 1; i <= 3; i++) {
        const s = this.$refs[`svgCircle_${ i }`],
          p = this.expand.wave.line[this.expand.circle.point[i - 1]];
        
        if (!s) continue;
        s.setAttribute('cx', p[0]);
        s.setAttribute('cy', p[1]);
      }
    },
    
    /**
     * 播放波浪
     */
    playWave(): void {
      const path = 'M' + this.expand.wave.line
        .filter((item: number[], index: number) => index <= this.expand.wave.current)
        .map((item: number[]) => item[0] + ',' + item[1]).join(' L');
      
      this.$refs.svgPath?.setAttribute('d', path);
      
      this.expand.wave.time += this.expand.wave.speed;
      this.expand.wave.current = Math.ceil(this.expand.wave.time);
      
      (this.expand.active && this.expand.wave.current < this.expand.wave.line.length) &&
      requestAnimationFrame(this.playWave);
    },
    
    /**
     * 设置圆
     * @param {number} position 位置
     */
    setCircle(position: number): void {
      this.expand.circle.target = this.expand.circle.point[position - 1];
    },
    
    /**
     * 播放圆
     */
    playCircle(): void {
      if (this.$refs.svgCircle) {
        const p = this.expand.wave.line[this.expand.circle.current];
        this.$refs.svgCircle.setAttribute('cx', p[0]);
        this.$refs.svgCircle.setAttribute('cy', p[1]);
      }
      
      this.expand.circle.target !== this.expand.circle.current &&
      (this.expand.circle.current = this.expand.circle.current + (
        this.expand.circle.target > this.expand.circle.current
          ? Math.ceil((this.expand.circle.target - this.expand.circle.current) / 10)
          : Math.floor((this.expand.circle.target - this.expand.circle.current) / 10)
      ));
      
      this.expand.active && requestAnimationFrame(this.playCircle);
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';
@image: '@{src_image}page/planStable/';
@am_w: 1920px;

.creatAnimation(am_peak_line_b, {
  0% {
    background-position-x: -100px;
  }
  100% {
    background-position-x: -(@am_w+100px);
  }
});

.creatAnimation(am_peak_line_a, {
  0% {
    background-position-x: 1000px;
  }
  100% {
    background-position-x: -@am_w+1000px;
  }
});

.peak_line {
  @t: 100s;
  overflow: hidden;
  .position(absolute, -10px, auto, auto, 50%);
  z-index: 0;
  width: 1200px;
  height: 350px;
  .transform(translateX(-50%));
  pointer-events: none;
  
  &::before,
  &::after {
    content: '';
    display: block;
    .position(bottom);
    z-index: 0;
    background-repeat: repeat-x !important;
    background-position-y: 0;
  }
  
  &::before {
    @h: 330px;
    height: @h;
    .bg('@{image}peak_line_wave.png', @am_w, @h);
    background-position-x: -100px;
    opacity: 0.7;
    .transform(scaleX(-1));
    .animation(am_peak_line_b @t linear infinite forwards);
  }
  
  &::after {
    @h: 300px;
    height: @h;
    .bg('@{image}peak_line_wave.png', @am_w, @h);
    background-position-x: 1000px;
    .animation(am_peak_line_a @t linear infinite forwards);
  }
  
  i {
    @style: closest-side, transparent 0%, @color_7 100%;
    display: block;
    .position(bottom);
    height: 120%;
    z-index: 1;
    .gradientRadial(@style);
  }
  
  svg {
    .position(top, 70px);
    z-index: 2;
    margin: auto;
    .transform(scale(@scale));
    
    path {
      stroke-width: 2px;
      stroke-linecap: round;
      fill: none;
    }
    
    circle {
      stroke: #ffffff;
      stroke-width: 2px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .peak_line {
    .transform(translate(-50%, -80px) scale(0.3));
  }
}
</style>